import { memo } from "react";
import { madeByOlaUrl } from "../../data/links.data";

function MadeByOlaBanner() {
  return (
    <div className="w-full pt-3 md:pt-5">
      <p className="text-lg md:text-xl font-black text-gray-500 font-boska">
        Website By{" "}
        <a
          href={madeByOlaUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="underline underline-offset-2 decoration-black"
        >
          OlaOluwa Adeyemo
        </a>
      </p>
    </div>
  );
}

export default memo(MadeByOlaBanner);
